export class TenantDto {
  keyId: string = '';
  id: string = '';
  code: string = '';
  name: string = '';
}